export const DISMISSED_USERNAME_BANNER_COOKIE = 'username_banner_dismissed';

export const PROJECTS_RESOURCE_NAME = 'your_projects';



// WEBPACK FOOTER //
// ./your_projects/constants.js